const style = {
  color: "#808080",
  fontSize: 13,
  fontWeight: 500
};

export function HeaderDetails(props) {
  return (<>
    <span style={ style }>{ props.text }</span>
  </>);
}
